import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const VerifyEmailPage = ({ onLogin }) => {
    const navigate = useNavigate();
    const [code, setCode] = useState('');
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${API_URL}/api/verify-email/`, { code, email });

            // Auto Login if tokens provided
            if (response.data.access && response.data.refresh) {
                // Auto Login
                if (onLogin) {
                    onLogin(response.data);
                }
            }
            setSuccess(true);
        } catch (err) {
            setError(err.response?.data?.error || "Code invalide ou expiré.");
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="login-container">
                <div className="simple-nav">
                    <button className="brand-home-link" onClick={() => navigate('/')}>ARCHIVIZAI</button>
                </div>
                <div className="login-card">
                    <h1 className="login-title">Compte Vérifié !</h1>
                    <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                        Votre email a été confirmé avec succès.<br />
                        Vous êtes maintenant connecté.
                    </p>
                    <button onClick={() => navigate('/app')} className="login-btn">
                        Accéder à l'application
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="simple-nav">
                <button className="brand-home-link" onClick={() => navigate('/')}>ARCHIVIZAI</button>
            </div>
            <div className="login-card">
                <h1 className="login-title">Vérifiez votre Email</h1>
                <p className="login-subtitle">Entrez le code à 6 chiffres reçu par email.</p>

                <form onSubmit={handleSubmit}>
                    <div className="input-group">
                        <label htmlFor="code">Code de vérification</label>
                        <input
                            type="text"
                            id="code"
                            className="input-field"
                            placeholder="123456"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            maxLength={6}
                            style={{ letterSpacing: '5px', textAlign: 'center', fontSize: '1.2rem' }}
                            required
                        />
                    </div>
                    <div className="input-group">
                        <label htmlFor="email">Confirmer votre Email</label>
                        <input
                            type="email"
                            id="email"
                            className="input-field"
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {error && <div className="error-message" style={{ color: 'red', marginBottom: '15px' }}>{error}</div>}

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? 'Vérification...' : 'Valider'}
                    </button>
                </form>
                <div className="login-footer">
                    <p>Pas reçu ? <button className="link-btn">Renvoyer le code</button></p>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailPage;
